module.exports = __webpack_public_path__ + "img/landing_box57.754fd265.jpg";